import {Component, input, ChangeDetectionStrategy} from '@angular/core';

import {Contact} from '../../types/contact'

import { ChipComponent } from '@softline/ui-core';
@Component({
    selector: 'soft-contact-card',
    imports: [
    ChipComponent
  ],
    templateUrl: './contact-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './contact-card.component.css'
})
export class ContactCardComponent {
  contact = input<Contact>()
}
